// extracted by mini-css-extract-plugin
module.exports = {"musterArticle":"muster-article_musterArticle__odRXA","article":"muster-article_article__HgBS_","image":"muster-article_image__1yMro"};